import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";




const ResetPassword = () => {
  const [config, setConfig] = useState(null);
const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [canResend, setCanResend] = useState(true);
  

  // Load config
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch(() => setMessage("Failed to load config."));
  }, []);

  // OTP Timer
  const startOtpTimer = (duration = 55) => {
    setCanResend(false);
    setOtpTimer(duration);

    const timerId = setInterval(() => {
      setOtpTimer((prev) => {
        const newVal = prev - 1;
        if (newVal <= 0) {
          clearInterval(timerId);
          setCanResend(true);
        }
        return newVal;
      });
    }, 1000);
  };

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  // Send OTP
  const handleSendOtp = async () => {
    if (!isValidEmail(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(
        `${config.BASE_URL}${config.RESET_PASSWORD_OTP}`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (data.status) {
        setOtpSent(true);
        setOtpVerified(false);
        setMessage("OTP sent successfully! Check your email.");
        // Save OTP temporarily for frontend verification
        localStorage.setItem(
          "otp_reset",
          JSON.stringify({ otp: data.otp, expiresAt: Date.now() + 300000 })
        );
        startOtpTimer(55);
      } else {
        setMessage(data.message || "Failed to send OTP.");
      }
    } catch (error) {
      setMessage("Server error while sending OTP.");
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP
  const handleVerifyOtp = () => {
    const storedOtp = JSON.parse(localStorage.getItem("otp_reset"));

    if (!storedOtp) {
      setMessage("OTP expired. Please request a new one.");
      return;
    }

    if (Date.now() > storedOtp.expiresAt) {
      setMessage("OTP expired. Please request a new one.");
      localStorage.removeItem("otp_reset");
      return;
    }

    if (otp.toString() === storedOtp.otp.toString()) {
      setMessage("OTP verified successfully!");
      setOtpVerified(true);
      setOtpSent(false);
      localStorage.removeItem("otp_reset");
    } else {
      setMessage("Invalid OTP. Please try again.");
    }
  };

  if (!config) return <p>Loading...</p>;

  return (
    <div style={{ maxWidth: "400px", margin: "auto" }}>
      <h2>Reset Password</h2>

      {/* Email Input */}
      <input
        type="email"
        placeholder="Enter registered email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={otpSent}
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      />

      {!otpSent && (
        <button
          onClick={handleSendOtp}
           disabled={otpVerified || loading}
          style={{ width: "100%", padding: "8px" }}
        >
          {loading ? "Sending..." : "Send OTP"}
        </button>
      )}

      {/* OTP Section */}
      {otpSent && !otpVerified && (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={{
              width: "100%",
              marginTop: "10px",
              padding: "8px",
            }}
          />

          <button
            onClick={handleVerifyOtp}
            disabled={loading || otp.length !== 6}
            style={{
              width: "100%",
              marginTop: "10px",
              padding: "8px",
            }}
          >
            Verify OTP
          </button>

          {!canResend && (
            <p style={{ marginTop: "5px", fontSize: "13px" }}>
              Resend OTP in {otpTimer}s
            </p>
          )}

          {canResend && (
            <button
              onClick={handleSendOtp}
              style={{
                width: "100%",
                marginTop: "10px",
                padding: "8px",
              }}
            >
              Resend OTP
            </button>
          )}
        </>
      )}

      {/* Reset Password Button */}
      {otpVerified && (
     <button
  style={{
    width: "100%",
    marginTop: "15px",
    padding: "8px",
    backgroundColor: "green",
    color: "white",
    border: "none",
  }}
  onClick={async () => {
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(`${config.BASE_URL}${config.SEND_RESET_LINK}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setMessage(data.message);

      // If successful, show popup and redirect
      if (data.status) {
        window.alert("Reset link was sent to your email.");
        navigate("/"); 
      }
    } catch (err) {
      setMessage("Server error while sending reset link.");
    } finally {
      setLoading(false);
    }
  }}
>
  {loading ? "Sending..." : "Reset Password"}
</button>

)}


      {message && (
        <p style={{ marginTop: "15px", color: "#555" }}>{message}</p>
      )}
    </div>
  );
};

export default ResetPassword;
